export enum HealthTravelerCarnetRoutes {
    Root = "/salud/carnets",
    CarnetList = "/salud/carnets/disponibles",
    CarnetListTargeted = "/salud/carnets/disponibles/:carnetId",
    CarnetDetail = "/salud/carnets/:productCode/poliza/:systemCode/:policyId",
}
